import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import LoadingDots from './LoadingDots';
import Loader from './Loader';

const ListingStep17 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [stdPolicy, setStdPolicy] = useState([]);
  const [lngPolicy, setLngPolicy] = useState([]);
  const [selectedStdPolicy, setSelectedStdPolicy] = useState(null);
  const [selectedLngPolicy, setSelectedLngPolicy] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isStandard, setIsStandard] = useState(true);
  const [nonrefundable, setNonrefundable] = useState(false);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [tempSelectedPolicy, setTempSelectedPolicy] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);
          try {
            const { std_cp_list = [], lng_cp_list = [] } = listingData;
            setStdPolicy(std_cp_list);
            setLngPolicy(lng_cp_list);
            // Set default selected policies
            setSelectedStdPolicy(std_cp_list[0]?.id);
            setSelectedLngPolicy(lng_cp_list[0]?.id);
            setLoading(false);
          } catch (error) {
            toast.error('Error parsing listing data: ' + error.message);
            console.error('Parsing error:', error);
            setLoading(false);
          }
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchListingData();
  }, [listingId]);

  
    const saveListing = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      const listing_id = listingId;
      const ts = Date.now();

      const updatedPropertyItem = {
        std_c_policy: selectedStdPolicy,
        c_nonrefundable: nonrefundable,
        long_c_policy: selectedLngPolicy,
      };

      console.log(selectedStdPolicy);
      console.log(selectedLngPolicy);

      const mergedData = { ...listingData, ...updatedPropertyItem };

      let catData = new FormData();
      catData.append('token', hostData.host_access_token);
      catData.append('listing_id', listing_id);
      catData.append('data', JSON.stringify(mergedData));
      catData.append('ts', ts);

      setNextLoading(true);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: `${params.baseURL}${params.endpoints.updateListing}`,
          data: catData,
        });

        if (response.data.status === 'done') {
          return true;
        } else {
          toast.error('Failed to save data');
          return false;
        }
      } catch (err) {
        toast.error('An error occurred while saving the listing');
        return false;
      }
    };

    

  const openDrawer = (isStandardPolicy) => {
    setIsStandard(isStandardPolicy);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    if (drawerOpen) {
      setTempSelectedPolicy(isStandard ? selectedStdPolicy : selectedLngPolicy);
    }
  }, [drawerOpen, isStandard]);

  // Determine which policy to display in the main view
  const currentStdPolicy = stdPolicy.find(policy => policy.id === selectedStdPolicy) || stdPolicy[0];
  const currentLngPolicy = lngPolicy.find(policy => policy.id === selectedLngPolicy) || lngPolicy[0];

  const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-17' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 17)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
              <div>
                <h4 className='ws-title'>Cancellation policy</h4>
              </div>
            </div>

          <div className='st1-desc-box'>
            <div className='ws-row'>
              <div className='col-md-12'>
                <p className='m-0' style={{textTransform:'uppercase'}}><strong>Standard policy</strong></p>
                <p>For stays booked with a duration of fewer than 28 nights.</p>
              </div>

              <div className='sptbds'>
                {currentStdPolicy && (
                  <div className='col-md-12 sptbds-o' style={{background:'#be9eff'}}>
                    <div className='policy--box' onClick={() => openDrawer(true)}>
                      <div className='policy-box-header' style={{display:'flex', alignItems:'center',justifyContent:'space-between',marginBottom:'1rem'}}>
                        <div className='pbhsdc'>
                          <img
                            src={'https://stcontent.blr1.digitaloceanspaces.com/stays/1722843850_stct.png'}
                            alt={'Untitled Listing'}
                            className='img-fluid'
                          />
                          <h4 className='mb-0' style={{textTransform:'uppercase'}}>{currentStdPolicy.title}</h4>
                        </div>
                        <p className='mb-0'><i className="fas fa-pencil-alt"></i></p>
                      </div>
                      <p>{currentStdPolicy.desc}</p>
                    </div>
                  </div>
                )}

                <div className='col-md-12 sptbds-o' style={{background:'#fed2d1'}}>
                  <div className='policy--box'>
                    <div className='policy-box-header'>
                      <h4 style={{textTransform:'uppercase'}}>Non-refundable</h4>
                      <p>
                        <input 
                          className="switch" 
                          type="checkbox" 
                          checked={nonrefundable}
                          onChange={(e) => setNonrefundable(e.target.checked)}
                        />
                      </p>
                    </div>
                    <p>In addition to Moderate, offer a non-refundable option guests pay 10% less, but you keep your payout no matter when they cancel.</p>
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <p className='m-0' style={{textTransform:'uppercase'}}><strong>Long-term stay policy</strong></p>
                <p>Covers stays of 28 nights or more.</p>
              </div>

              {currentLngPolicy && (
                <div className='col-md-12'>
                  <div className='policy-box' onClick={() => openDrawer(false)}>
                    <div className='policy-box-header'>
                      <p>{currentLngPolicy.title}</p>
                      <p><i className="fas fa-pencil-alt"></i></p>
                    </div>
                    <p>{currentLngPolicy.desc}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
              <div className='blog-box'>
                  <div class="blog">
                      <div class="blog-image">
                          <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                          <div class="date">May 08, 2025</div>
                      </div>
                      <div class="blog-content">
                          <h2>What is Lorem Ipsum?</h2>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                          <a href="#">Read More</a>
                      </div>
                  </div>
              </div>
              <div className="faq-sticky">
                  {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                      <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                          backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                      >
                      {faq.question}
                      <i
                          className={`fas ${
                          activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                          style={{
                          transition: "transform 0.3s ease",
                          }}
                      ></i>
                      </div>
                      {activeIndex === index && (
                      <div className='faqs-ans-box'>
                          {faq.answer}
                      </div>
                      )}
                  </div>
                  ))}
              </div>
          </div>
        </div>

      </div>

      <Dialog
        open={drawerOpen}
        onClose={closeDrawer}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <h4 style={{ margin: 0, textTransform: 'uppercase' }}>
            {isStandard ? "Select Standard Policy" : "Select Long-Term Policy"}
          </h4>
        </DialogTitle>

        <DialogContent>
          {(isStandard ? stdPolicy : lngPolicy).map((policy) => (
            <div className='drawer-policy-box' key={policy.id}>
              <label className='policy-radio-input'>
                <div className='policy-radio-txt-box'>
                  <img src='/assets/img/icons/policy_icon.svg' alt='' />
                  <span>
                    <div>{policy.title}</div>
                    <div>{policy.desc}</div>
                  </span>
                </div>
                <div className="circle"></div>
                <input
                  type="radio"
                  value={policy.id}
                  checked={tempSelectedPolicy === policy.id}
                  onChange={() => setTempSelectedPolicy(policy.id)}
                />
              </label>
            </div>
          ))}
        </DialogContent>

        <DialogActions style={{ justifyContent: 'space-between', padding: '16px 24px', paddingTop:'0' }}>
          <button
            className="btn btn-blank"
            style={{ flex: '1', padding: '10px 24px' }}
            onClick={() => {
              if (isStandard) {
                setSelectedStdPolicy(tempSelectedPolicy);
              } else {
                setSelectedLngPolicy(tempSelectedPolicy);
              }
              closeDrawer();
            }}
          >
            Done
          </button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default ListingStep17;
